<template lang="html">
  <tr class="customer-domain-row" :id="id">
    <td colspan="2">
      <div class="customer-row" v-if="customer.uuid">
        <div class="section">
          <chevrons
            :is-open="customerAccess.isOpen"
            :disabled="isChevronDisabled"
            @on-chevon-click="toggleIsOpen"
          />
          <span class="expand" @click.stop="toggleIsOpen">
            {{ customer.name }}
          </span>
        </div>
        <div class="section access">
          {{ isFullAccess ? $t("full") : $t("partial") }}
          <div v-if="customerAccess.delete" class="loader"></div>
          <svg
            v-else
            class="delete-icon"
            tabindex="0"
            @keydown.enter.stop="toggleDeleteModal"
            @click.stop="toggleDeleteModal"
          >
            <use
              xlink:href="@/assets/icons/utility-sprite/svg/symbols.svg#delete"
            />
          </svg>
        </div>
      </div>
      <customer-domain-collapse-details
        v-if="customerAccess.isOpen"
        :id="`customer-access-detail-${customerData.uuid}`"
        :customer="customerData"
        @on-customer-domain-full-access="onCustomerDomainFullAccess"
      />
      <simple-modal
        :show="displaySimpleModal"
        :message="getMessageText(messages.ARE_YOU_SURE)"
        :cancel-text="getMessageText(messages.CANCEL)"
        :ok-text="getMessageText(messages.OK)"
        @on-simple-modal-cancel="onCancelDeleteElement"
        @on-simple-modal-ok="onConfirmDeleteElement"
      />
    </td>
  </tr>
</template>

<script lang="js">
  import { MUTATION_NAME, TOAST_OPTIONS } from "@/static/global-variables";
  import DistributionChannelsService from "@/services/distributionChannelsService";
  import Chevrons from "@/views/drag-drop-pages/components/Chevrons";
  import SimpleModal from "@/views/drag-drop-pages/components/modal/SimpleModal";
  import CustomerDomainCollapseDetails from "@/components/custom-display-elements/tabs/customer-domains/CustomerDomainCollapseDetails";

  export default  {
    name: "customer-domain-row",
    components: {
      SimpleModal,
      Chevrons,
      CustomerDomainCollapseDetails
    },
    props: {
      id: String,
      customer: {
        type: Object,
        default: function() {
          return {}
        }
      }
    },
    data () {
      return {
        displaySimpleModal: false,
        isFullAccess: false
      }
    },
    computed: {
      messages() {
        return this.$store.state.messages;
      },
      selectedAccess() {
        return this.$store.getters[MUTATION_NAME.CUSTOMER_DOMAIN_WIDGET_ACCESS] || {};
      },
      customerAccess() {
        return {...this.selectedAccess[this.customer.uuid] || {}};
      },
      isChevronDisabled() {
        return this.customerAccess.delete || this.customerAccess.update || this.isWidgetUpdate;
      },
      isWidgetUpdate() {
        return Object.values(this.customerAccess).some(e => e.update);
      },
      customerData() {
        return JSON.parse(JSON.stringify(this.customer));
      }
    },
    mounted () {
      this.isFullAccess = this.customerAccess.name? this.customerAccess.fullAccess : this.customer.fullAccess;
    },
    methods: {
      toggleIsOpen() {
        this.customerAccess.isOpen = !this.customerAccess.isOpen;
        this.commitChanges();
      },
      commitChanges() {
        this.$store.commit(MUTATION_NAME.CUSTOMER_DOMAIN_WIDGET_ACCESS, { customer: this.customer.uuid, access: this.customerAccess });
      },
      onCustomerDomainFullAccess(fullAccess) {
        this.isFullAccess = fullAccess;
      },
      toggleDeleteModal() {
        this.displaySimpleModal = !this.displaySimpleModal;
      },
      onCancelDeleteElement() {
        this.toggleDeleteModal();
      },
      setCustomerDeleteFlag(isDelete) {
        const customerAccess = this.customerAccess;
        customerAccess.delete = isDelete;
        this.updateCustomerAccess(this.customer.uuid, customerAccess);
      },
      onConfirmDeleteElement() {
        this.setCustomerDeleteFlag(true);
        this.toggleDeleteModal();
        DistributionChannelsService.deleteCustomerDomain(this.customer.uuid)
        .catch((e) => {
          this.setCustomerDeleteFlag(false);
          this.$bvToast.toast(this.getMessageText(this.messages.SAVE_ERROR), TOAST_OPTIONS.bottomCenter);
          console.error(e);
        });
      },
      updateCustomerAccess(customer, access) {
        this.$store.commit(MUTATION_NAME.CUSTOMER_DOMAIN_WIDGET_ACCESS, { customer, access });
      },
    }
  }
</script>

<style scoped lang="scss">
  @import "@/styles/components/main";
  .customer-domain-row {
    td {
      padding: 0;
    }
    .customer-row {
      display: flex;
      min-height: 2rem;
      align-items: center;
      .section {
        display: flex;
        align-items: center;
        gap: 0.3rem;
        flex-basis: 50%;
        max-width: 50%;
        padding: 0.25rem 0.5rem;
        .expand {
          cursor: pointer;
        }
        &.access {
          display: flex;
          justify-content: space-between;
          padding-right: 0.5rem;
          .delete-icon {
            cursor: pointer;
            height: 1rem;
            width: 1rem;
            fill: var(--SF_ERROR_RED);
          }
          .loader {
            height: 1.2rem;
            margin: initial;
          }
        }
      }
    }
  }
</style>
